import { createContext } from 'react';

const ClassExperimentContext = createContext({
  expName: 'special_class_details_page_exp_v2',
  expVar: 'null',
  isFetched: false
});

export default ClassExperimentContext;
